import { render, staticRenderFns } from "./BatchSetting.vue?vue&type=template&id=234f3ff8"
import script from "./BatchSetting.vue?vue&type=script&lang=js"
export * from "./BatchSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports